// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-item[data-v-9d5afa34]{display:none}.password-validator[data-v-9d5afa34]{margin-top:.5rem;font-weight:600}.password-validator .passStrengthWeak[data-v-9d5afa34]{color:#b7213c}.password-validator .passStrengthGood[data-v-9d5afa34]{color:#ff9720}.password-validator .passStrengthStrong[data-v-9d5afa34]{color:#21a330}", ""]);
// Exports
module.exports = exports;
